import { createSelector } from "reselect";

import { getEmails } from "../root";
import { selectSaleTitleWithCodeAndDateByIdLookup } from "../sales";

export const selectEmailAggridData = createSelector(
  [getEmails, selectSaleTitleWithCodeAndDateByIdLookup],
  (emails, saleTitleWithCodeAndDateByIdLookup) =>
    Object.values(emails).map(email => ({
      email,
      id: email.id,
      livestockSale: {
        title: saleTitleWithCodeAndDateByIdLookup[email.livestockSaleId],
      },
    })),
);
